import { useContext, useMemo } from 'react';

import { WWContext, type WWContextValue } from '../components/WWContext';
import { useIsLiteSite } from '../lib/useIsLiteSite';

import {
  isWwsWeddingWebsiteV2,
  type Maybe,
  type Wws_Page,
  type Wws_WeddingWebsiteV2,
} from '../types/graphql';

export function useVisiblePages(): Maybe<Wws_Page[]> | undefined {
  const { data } = useContext<WWContextValue>(WWContext);

  const isLiteSite = useIsLiteSite();

  return useMemo<Wws_Page[]>(() => {
    if (isWwsWeddingWebsiteV2(data?.weddingWebsiteResult)) {
      if (!data?.weddingWebsiteResult.pages) {
        return [];
      }

      if (isLiteSite) {
        return pagesWithContent(data.weddingWebsiteResult);
      }

      return data.weddingWebsiteResult.pages.filter((page: Wws_Page): boolean =>
        Boolean(page.show)
      );
    }

    return [];
  }, [data, isLiteSite]);
}

function pagesWithContent(wwsResult: Wws_WeddingWebsiteV2): Wws_Page[] {
  const { pages } = wwsResult;

  if (!pages) {
    return [];
  }

  return pages.filter((page: Wws_Page): boolean => {
    return page.items.length > 0;
  });
}
